module.exports = __webpack_public_path__ + "static/media/phong-an.c433fd88.png";